<script>
import { mapActions } from "vuex";
import PartnerDetail from "@/components/partner/partner-detail.vue";
export default {
  mame: "CustomerListing",
  components: {
    "partner-detail": PartnerDetail
  },
  data() {
    return {
      partners: [],
      editDialog: false
    };
  },
  computed: {
    headers: function() {
      if (this.partners.length == 0) return;
      return this.getHeaders(this.partners[0]);
    }
  },
  methods: {
    ...mapActions("partner", { getPartnerData: "getPartnerData" }),
    load() {
      this.getPartnerData({ url: "commissions/ListPartners" })
        .then(data => {
          this.partners = data;
        })
        .catch(() => {});
    },
    edit(item) {
      this.$refs.detail.loadData(item.dealerId);
      this.editDialog = true;
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped>
</style>


<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <slot/>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row  justify="center">
        <v-dialog v-model="editDialog" persistent fullscreen>
          <v-btn color="primary" dark slot="activator" @click="editDialog = true">Open Dialog</v-btn>
          <v-container fluid>
            <partner-detail ref="detail" @closeEdit="editDialog = false"></partner-detail>
          </v-container>
        </v-dialog>
      </v-row>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="partners"
      class="elevation-1"
      item-key="id"
      :pagination.sync="pagination"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td
          :class="`text-xs-${name.align}`"
          v-for="(name, index) in headers.filter(x => x.text !== 'Actions')"
          :key="index"
        >
          <div v-if="isDateColumn(name.value)">{{props.item[name.value] | formatDate}}</div>
          <div v-else>{{ props.item[name.value] }}</div>
        </td>
        <td class="text-center">
          <v-icon small @click="edit(props.item)">edit</v-icon>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
